<mat-card-header class="layout-row gap-5percent">
  <fa-icon class="main-icon" icon="users" size="3x"></fa-icon>
  <mat-card-title-group>
    <div class="mat-typography">
      <mat-card-title>
        <h2>
          {{ groupData.name }}
          <span [className]="groupData.status.code | statusLookup">
            <fa-icon
              matTooltip="{{ groupData.status.value }}"
              matTooltipPosition="right"
              icon="circle"
              size="lg"
            ></fa-icon>
          </span>
        </h2>
      </mat-card-title>
      <mat-card-subtitle>
        <p>
          {{ 'labels.inputs.Account No' | translate }}: {{ groupData.accountNo }}
          {{ groupData.externalId ? '| External ID: ' + groupData.externalId : '' }}
        </p>
      </mat-card-subtitle>
    </div>
  </mat-card-title-group>
</mat-card-header>

<mat-card-content>
  <mat-tab-group>
    <mat-tab label="Details">
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Activation Date' | translate }}
        </div>

        <div class="flex-50">
          {{ groupData.activationDate | dateFormat }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Associated Officer' | translate }}
        </div>

        <div class="flex-50">
          {{ groupData.staffName }}
        </div>

        @if (groupData.centerName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Associated Center' | translate }}
          </div>
        }

        @if (groupData.centerName) {
          <div class="flex-50">
            {{ groupData.centerName }}
          </div>
        }

        @if (groupData.collectionMeetingCalendar && groupData.collectionMeetingCalendar.nextTenRecurringDates[0]) {
          <div class="mat-body-strong flex-50">
            {{ 'labels.inputs.Next Meeting Date' | translate }}
          </div>
        }

        @if (groupData.collectionMeetingCalendar && groupData.collectionMeetingCalendar.nextTenRecurringDates[0]) {
          <div class="flex-50">
            {{ groupData.collectionMeetingCalendar.nextTenRecurringDates[0] | dateFormat }}
          </div>
        }

        @if (groupData.collectionMeetingCalendar && groupData.collectionMeetingCalendar.humanReadable) {
          <div class="mat-body-strong flex-50">
            {{ 'labels.inputs.Meeting Frequency' | translate }}
          </div>
        }

        @if (groupData.collectionMeetingCalendar && groupData.collectionMeetingCalendar.humanReadable) {
          <div class="flex-50">
            {{ groupData.collectionMeetingCalendar.humanReadable }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Number of Clients' | translate }}
        </div>

        <div class="flex-50">
          {{ clientData ? clientData.length : '' }}
        </div>
      </div>
    </mat-tab>

    @if (groupAccountsData && groupAccountsData.loanAccounts) {
      <mat-tab label="Loan Accounts">
        <LOSx-loan-account-table [loanAccountData]="groupAccountsData.loanAccounts"></LOSx-loan-account-table>
      </mat-tab>
    }

    @if (groupAccountsData && groupAccountsData.savingsAccounts) {
      <mat-tab label="Savings Accounts">
        <LOSx-savings-account-table
          [savingsAccountData]="groupAccountsData.savingsAccounts"
        ></LOSx-savings-account-table>
      </mat-tab>
    }
  </mat-tab-group>
</mat-card-content>
